module.exports = __webpack_public_path__ + "img/img_register.4fb7a31d.png";